var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBraavosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2893_39583)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.599609,
    y: -0.898438,
    width: 24.6,
    height: 25.5,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3926 4.04589C14.4172 4.08862 14.3845 4.14136 14.3359 4.14136C13.3525 4.14136 12.5532 4.9382 12.5344 5.92838C12.1977 5.86404 11.8488 5.8592 11.5041 5.91864C11.4803 4.93298 10.683 4.14136 9.70283 4.14136C9.65419 4.14136 9.62143 4.08858 9.64609 4.04582C10.1221 3.22056 11.0067 2.66602 12.0193 2.66602C13.032 2.66602 13.9166 3.22059 14.3926 4.04589Z",
    fill: "#FF9A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4153 10.2039C17.6999 10.2922 17.9691 10.037 17.8692 9.75122C16.9734 7.19076 14.1452 6.14461 12.0058 6.14461C9.86274 6.14461 6.97145 7.2242 6.14094 9.76451C6.04813 10.0484 6.31659 10.295 6.59701 10.2071L11.7883 8.57895C11.9127 8.53991 12.0458 8.53969 12.1704 8.5783L17.4153 10.2039Z",
    fill: "#FF9A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12924 10.6469L11.7923 8.88898C11.916 8.85057 12.0482 8.85047 12.1719 8.88868L17.8704 10.6477C18.3435 10.7938 18.6673 11.2399 18.6673 11.7457V17.0154C18.6454 18.3017 17.5164 19.3327 16.2601 19.3327H14.1733C13.9671 19.3327 13.8 19.1619 13.8 18.9508V17.1032C13.8 16.3757 14.2207 15.7172 14.8717 15.4257C15.7443 15.0351 16.7766 14.5066 16.9708 13.4462C17.0334 13.104 16.8154 12.7738 16.4818 12.706C15.6384 12.5344 14.7034 12.6006 13.9128 12.9626C13.0151 13.3735 12.7803 14.057 12.6934 14.975L12.5881 15.9639C12.5559 16.2662 12.279 16.4977 11.9821 16.4977C11.6749 16.4977 11.4446 16.2583 11.4113 15.9456L11.3079 14.975C11.2334 14.1887 11.0985 13.4249 10.3043 13.0614C9.39835 12.6466 8.48796 12.5089 7.51947 12.706C7.18593 12.7738 6.96788 13.104 7.03055 13.4462C7.22641 14.5159 8.25061 15.0322 9.12964 15.4257C9.78061 15.7172 10.2013 16.3757 10.2013 17.1032V18.9505C10.2013 19.1616 10.0343 19.3327 9.82803 19.3327H7.74125C6.48491 19.3327 5.35593 18.3017 5.33398 17.0154V11.7443C5.33398 11.2392 5.65694 10.7935 6.12924 10.6469Z",
    fill: "#FF9A0A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166667,
    y: 0.166667,
    width: 23.6667,
    height: 23.6667,
    rx: 11.8333,
    stroke: "white",
    strokeWidth: 0.333333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2893_39583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraavosLogo);
export default __webpack_public_path__ + "static/media/BraavosLogo.df1c225bddd7ec5d8fb0f8faacb4ced1.svg";
export { ForwardRef as ReactComponent };